import React, { useEffect, useState } from "react";
import FilesStatus from "./filesStatus";
import TableCmp from "./TableCmp";
import { useQuery, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { ACTIVE_DIV, WORK_FLOW_TYPE } from "../../config/cacheKey";
import { GetCartablesResponse } from "../../models/cartable.model";
import { GetCartables } from "../../services/cartable.service";
import { setstateCartable } from "../../redux/activeState/activeStateAction";
import ToolsCmp from "./ToolsCmp";
import { useHistory } from "react-router-dom";
export default function LoanPage() {
  //test

  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  let test = queryClient.getQueryData(WORK_FLOW_TYPE)
    ? queryClient.getQueryData(WORK_FLOW_TYPE)!
    : "SupplierSettlementCartable";

  let history = useHistory<{ refetchStatus: boolean }>();

  const [activeState, setActiveState] = useState<any>(queryClient.getQueryData(ACTIVE_DIV));
  useEffect(() => {
    if (history.location.state != undefined && history.location.state.refetchStatus == true) {
      queryClient.setQueryData(ACTIVE_DIV, 0);
      setActiveState(0);
      refetch();
      history.replace({ state: { refetchStatus: false } })
    }
  }, [history.location.state])
  useEffect(() => {
    setActiveState(queryClient.getQueryData(ACTIVE_DIV));
  })

  let { data: cartableData, isLoading, refetch } = useQuery<GetCartablesResponse[]>(
    ["GetCartables",],

    (): Promise<GetCartablesResponse[]> => {
      //todo
      return GetCartables({
        workflowType: "SupplierSettlementCartable",
      });
    },
  );

  if (isLoading) {
    return <></>;
  } else {
    if (cartableData != null) {
      if (cartableData.length > 0) {
        cartableData[activeState ? activeState : 0].status = "success";
        dispatch(setstateCartable({ stateCartable: cartableData[activeState ? activeState : 0].state }));
        return (
          <div>
            {/* <ToolsCmp />
            <br /> */}
            <FilesStatus
              workFlowType="SupplierSettlementCartable"
              cartableData={cartableData}
            />
            <TableCmp />
          </div>
        );
      }
      return (
        <div>
          <img
            className="classCenter"
            style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
            src="images/empthuCartable.png"
          />
        </div>
      );
    }
  }
  //test
}
